import {breakpoints} from 'epic-fortnite-styles/constants/Breakpoints';
import React from 'react';
import styled from 'styled-components';

export interface Props {
  desktop?: string;
  mobile?: string;
  tablet?: string;
  alt?: string;
  className?: string;
}

const Image = styled.img`
  width: 100%;
`;

/*
 * Responsive desktop-first image component
 */
const ResponsiveImage = ({mobile, tablet, desktop, alt = '', className}: Props) => {
  return (
    <picture className={className}>
      {mobile ? <source srcSet={mobile} media={breakpoints.mobileL} /> : null}
      {tablet ? <source srcSet={tablet} media={breakpoints.tablet} /> : null}
      <Image src={desktop ?? tablet ?? mobile} alt={alt} />
    </picture>
  );
};

export default ResponsiveImage;
